<template>
  <v-app-bar
    class=main--text
    color=primary
    dark>
      <v-toolbar-title
        class="title--text">Prosense</v-toolbar-title>
      <v-spacer></v-spacer>
  </v-app-bar>
</template>

<script>
import logoWhite from '@/assets/logo_white.png'
export default {
  data () {
    return {
      logoWhite
    }
  }
}
</script>
